import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {ISubMenuItem} from "../../../../../app/core/interfaces/IMenuItem.ts";
import useMenu from "./useMenu.tsx";
import ComingSoon from "../../../../partials/ComingSoon.tsx";
import {ulid} from "ulid";

const MenuItem = ({ sm }: {sm: ISubMenuItem}) => {
  if (!sm.submenu || sm.submenu?.length === 0) return <SidebarMenuItem
    to={sm.redirectTo || ''}
    title={sm.name}
    soon={sm.soon}
    hasBullet={true}
  />

  return <SidebarMenuItemWithSub
    to={sm.redirectTo || ''}
    title={sm.name}
    soon={sm.soon}
    hasBullet={true}
  >
    {sm.submenu?.map((ssm) => {
      return <MenuItem key={ulid()} sm={ssm} />
    })}
  </SidebarMenuItemWithSub>
}

const SidebarMenuMain = () => {
  const menu = useMenu()

  return (
    <>
      {/*<SidebarMenuItem*/}
      {/*  to={ERoutes.DASHBOARD}*/}
      {/*  icon='home'*/}
      {/*  title={intl.formatMessage({id: 'MENU.DASHBOARD'})}*/}
      {/*/>*/}
      {menu.map((menuItem) => {
        if (menuItem.hide) return null

        return <div key={ulid()}>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                {menuItem.name}
                {menuItem.soon && <ComingSoon className={'ms-2 float-end'} />}
              </span>
            </div>
          </div>

          {!menuItem.soon && menuItem.menu.map((mim) => {
            if (mim.hide) return null

            if (mim.submenu?.length === 0) {
              return <SidebarMenuItem
                key={ulid()}
                to={mim.redirectTo || ''}
                icon={mim.icon}
                title={mim.name}
                soon={mim.soon}
                fontIcon={mim.fontIcon}
                badge={mim.badge}
              />
            }

            return <SidebarMenuItemWithSub
              to={mim.redirectTo || ''}
              icon={mim.icon}
              title={mim.name}
              soon={mim.soon}
              fontIcon={mim.fontIcon}
            >
              {mim.submenu?.map((sm) => {
                  if (sm.hide) return null
                  return <MenuItem key={ulid()} sm={sm} />
              })}
            </SidebarMenuItemWithSub>
          })}
        </div>
      })
      }
    </>
  )
}

export {SidebarMenuMain}
